(function () {

    'use strict';
    angular.module('app')
        .controller('createAccountController', ['$location', '$routeParams', 'accountsService', 'stateService', 'vcRecaptchaService', createAccountController]
        );

    function createAccountController($location, $routeParams, accountsService, stateService, vcRecaptchaService) {
        //$scope.model = stateService.model;
        var vm = this;
        vm.model = {};
        vm.model.key = '6LfM3P4SAAAAAKkiWK7WwVGRo4d4sJPcD2qdnxsR';
        vm.widgetId = null;
        vm.response = null;

        if (vm.model.type == undefined)
            vm.model.type = 0; //User

        accountsService.getAuthenticatedAccount()
            .then(function (response) {
                vm.model.isAdmin = (response.accountType === AccountType.Admin ||
                    response.accountType === AccountType.SuperAdmin);
                vm.model.isSuperAdmin = (response.accountType === AccountType.SuperAdmin);
                
            });

        vm.setResponse = function (response) {
            console.info('Response available');
            vm.response = response;
        };

        vm.setWidgetId = function (widgetId) {
            console.info('Created widget ID: %s', widgetId);
            vm.widgetId = widgetId;
        };

        vm.cbExpiration = function () {
            console.info('Captcha expired. Resetting response object');
            vcRecaptchaService.reload(vm.widgetId);
            vm.response = null;
        };

        vm.submit = function () {
            
            vm.model.submitted = true;
            
            if (!vm.createAccountForm.$valid) {
                return;
            }

            vm.model.working = true;

            var account = {
                firstName: vm.model.firstName,
                lastName: vm.model.lastName,
                email: vm.model.email,
                companyName: vm.model.companyName,
                type: vm.model.type,
                ipAuthentication: true,
                password: vm.model.password,
                jobTitle: vm.modal.jobTitle
            };

            vm.model.complete = false;
            var recapture = {
                response: vm.response
            };
            try {
                accountsService.createAccount(account, $routeParams.ct, recapture)
                    .then(function () {
                        vm.model.complete = true;
                        vm.model.success = true;
                    },
                    function (response) {
                        vm.model.working = false;

                        vm.model.error = response.errors[0].message;
                        vm.model.complete = true;
                        vm.model.success = false;

                        vcRecaptchaService.reload(vm.widgetId);
                    });
            } catch (e) {
                console.log(e);
            }
        };

    }
})();